"use strict";

exports.__esModule = true;
exports["default"] = Home20;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Home20(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M185.7-166.5c0-16-10.3-25.2-25.1-25.2-16.6 0-25.1 11.5-25.1 25.2v25.2l50.2 50.4v-75.6zM17 3c0-.6-.4-1-1-1-.7 0-1 .5-1 1v1l2 2V3zM19.8 10.5l-9-9-.2-.2c-.1-.1-.2-.1-.3-.2-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3.1-.1 0-.2.1-.3.2l-.2.2-9 9c-.3.4-.3.8 0 1.1.3.3.8.3 1.1 0L10 3l8.6 8.6c.3.3.8.3 1.1 0 .4-.3.4-.7.1-1.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 5l-7 7v7h5v-6h4v6h5v-7l-7-7z"
  }));
}